import axios from 'axios'
import CONFIG from '@/config'

axios.defaults.withCredentials = true

const ax = axios.create({
  // baseURL:  URL_PATH[WHERE]
  // baseURL: 'http://172.20.54.226:8080'
  baseURL: CONFIG.baseUrl
})

// 请求拦截器
ax.interceptors.request.use(
  (config) => {
    if (
      config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'delete' ||
      config.method === 'patch'
    ) {
      //   config.data = querystring.stringify(config.data)
    }
    // if ((window as any).localStorage.getItem('TOKEN')) {
    //  config.headers.Authorization = `Bearer ${JSON.parse((window as any).localStorage.getItem('TOKEN') || '').token}`
    // }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 请求结果拦截器
ax.interceptors.response.use(
  (response) => {
    // 请求结果报错。同一处理
    return response.data
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default ax
